import { CAMINO } from '@somnhold/content';
import type { LitterRules } from '../types.ts';
import { base } from './litter-rules.ts';
import type { BridgeLayout, RidgeLayout, WalkLayout } from './pasarela-layout.ts';

/**
 * The stretcher's rules for the cleric's chapter 2 (docs/sendas/clerigo.md, «La pasarela»; content CAMINO.ridge, walk,
 * bridge), from their layouts (battle/pasarela-layout.ts): the fight's builder (campaign/sendas.ts) and the renderer's
 * scenes build them the same way. Life in hit points worked out by the caller (seconds of D).
 */

export const ridgeRules = (L: RidgeLayout): LitterRules => {
  const C = CAMINO.ridge;
  return {
    ...base(),
    kind: 'ridge',
    pace: C.pace,
    way: L.way.map((p) => ({ ...p })),
    dens: L.dens.map((d) => ({ ...d })),
    foes: null,
    crows: null,
    limpet: null,
    mirrors: null,
    ridge: {
      chapels: L.chapels.map((c) => ({ ...c })),
      shade: C.shade,
      volley: { ...C.volley },
      gargoyle: { first: C.gargoyle.first, every: C.gargoyle.every, n: [C.gargoyle.n[0], C.gargoyle.n[1]] },
      ledge: L.ledge,
      arriero: { ...L.arriero },
    },
  };
};

export const walkRules = (L: WalkLayout, burn: number): LitterRules => {
  const C = CAMINO.walk;
  return {
    ...base(),
    kind: 'walk',
    pace: C.pace,
    near: C.near,
    way: L.way.map((p) => ({ ...p })),
    dens: [],
    foes: null,
    crows: null,
    limpet: null,
    mirrors: null,
    walk: {
      landings: L.landings.map((h) => ({ ...h })),
      spans: L.spans.map((sp) => sp.map((h) => ({ ...h }))),
      posts: L.posts.map((p) => ({ ...p })),
      waySpan: [...L.waySpan],
      moon: { ...L.moon },
      start: [...L.start0],
      burn: C.burn,
      cover: C.cover,
      stand: C.stand,
      reach: C.reach,
      fallBp: C.fallBp,
      slip: { ...C.slip },
      gargoyle: { ...C.gargoyle },
      mend: C.mend,
      mendReach: C.mendReach,
      beam: burn,
    },
  };
};

export const bridgeRules = (L: BridgeLayout, mangonelHp: number, limpetHp: number): LitterRules => {
  const C = CAMINO.bridge;
  const K = C.limpet;
  return {
    ...base(),
    kind: 'bridge',
    pace: C.pace,
    way: L.way.map((p) => ({ ...p })),
    dens: L.dens.map((d) => ({ ...d })),
    foes: null,
    crows: null,
    // The limpets climb out of the fog one now and then (no bends to burst at: `near` 0).
    limpet: { hp: limpetHp, speed: K.speed, drainBp: K.drainBp, heroBp: K.heroBp, burst: 0, near: 0, trickle: K.trickle, cap: K.cap, leap: K.leap, bends: [] },
    mirrors: null,
    span: {
      planks: L.planks.map((k) => ({ r: k.r, cells: k.cells.map((h) => ({ ...h })) })),
      hang: C.hang,
      mend: C.mend,
      mendReach: C.mendReach,
      mangonel: { hp: mangonelHp, x: L.mangonel.x, y: L.mangonel.y, first: C.mangonel.first, every: C.mangonel.every, warn: C.mangonel.warn, r: C.mangonel.r, heroBp: C.mangonel.heroBp, tessa: C.mangonel.tessa },
      gargoyle: { ...C.gargoyle },
    },
  };
};
